module.exports = __webpack_public_path__ + "static/media/jadranka-rebeka-anic.c9616503.jpg";